'use strict';

function CompanyNoteService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/notes/:noteId', {}, {
    "update": {
      method: "PUT"
    }
  });
}

angular.module('dokiv')
  .factory('CompanyNoteService', [
    '$resource',
    'config',
    CompanyNoteService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/notes/CompanyNoteService.js
// module id = 362
// module chunks = 0